<template>
  <section class="works row">
    <aside class="col-xs-12 col-md-6 custome_padding">
      <div class="box big-img">
        <img src="@/assets/works/group-5.png" alt="">
      </div>
    </aside>
    <aside class="col-xs-12 col-md-6 custome_padding">
      <div class="box">
        <div class="work-group">
          <div class="tile">
            <div class="box">
              <img src="@/assets/works/group-6.png" alt="">
            </div>
          </div>
          <div class="tile">
            <div class="box more_product">
                <a href="/"> OUR PRODUCTS</a>
            </div>
          </div>
          <div class="tile">
            <div class="box more_product">
                <a href="/"> MORE WORKS</a>
            </div>
          </div>
          <div class="tile">
            <div class="box">
              <img src="@/assets/works/group-7.png" alt="">
            </div>
          </div>

        </div>
     </div>
    </aside>
  </section>
</template>

<script>
export default {
  name: 'works',
  props: {
    title: String
  }
}
</script>

<style scoped lang="scss">
.custome_padding{
  padding: 0 0.12rem;
}
.works{
  margin: 0 -0.12rem;
  img{
    width:100%;
    display: block;
    box-shadow: 0 2px 194px 0 rgba(0, 0, 0, 0.28);
  }
  .big-img{
    margin-bottom: 3px;
  }

}
.work-group{
  display: flex;
  flex-wrap: wrap;
  .tile{
    width: 50%;
  }
}
.more_product{
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  a{
    color:$white;
    text-decoration: none;
    position: relative;
    transition: all 0.2s;
    &:after{
      content:'';
      position: absolute;
      width:40%;
      top:25px;
      left: 60%;
      height: 2px;
      transition: all 0.2s;
      background: $yellow;;
    }
    &:hover{
      &:after{
        // right: initial;
        left: 0;
        width:60%;
      }
    }
  }
  
}
</style>
